import { render, staticRenderFns } from "./SitchCurrencyInput.vue?vue&type=template&id=7102d55f&scoped=true&"
import script from "./SitchCurrencyInput.vue?vue&type=script&lang=ts&"
export * from "./SitchCurrencyInput.vue?vue&type=script&lang=ts&"
import style0 from "./SitchCurrencyInput.vue?vue&type=style&index=0&id=7102d55f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7102d55f",
  null
  
)

export default component.exports